import { useTranslation } from 'react-i18next';

export const useCompaniesTranslation = () => useTranslation('companies');
